<template>
  <form @submit.prevent="submit">
    <fields />
    <b-button type="submit" variant="primary">
      {{ $t('general.save') }}
    </b-button>
    <b-button type="button" variant="light" class="ml-2" @click="cancel">
      {{ $t('general.cancel') }}
    </b-button>
  </form>
</template>

<script>
import { ResourceFormMixin } from 'stylemix-vue-admin'
import AirportRatesApi from './Api'

export default {
  name: 'AirportRateForm',

  mixins: [ResourceFormMixin],

  props: {
    vehicleId: { type: [Number, String], required: true },
    airportRateId: { type: Number, required: true },
  },

  data() {
    return {
      base: 'pricing-periods',
    }
  },

  mounted() {
    this.loadForm()
  },

  methods: {
    api() {
      return new AirportRatesApi(this.vehicleId)
    },

    submit() {
      this.save().then(result => {
        this.$toast.success(result.message)
      })
    },
  },
}
</script>
